const focusRoutes = [
  {
    path: '/follow',
    redirect: '/follow/project',
    name: 'Focus',
    component: () => import('@/views/follow/follow'),
    meta: {
      layout: 'DefaultLayout',
      title: '我的关注',
      inNavbar: true,
      pageType: 'public'
    },
    children: [
      {
        path: 'project',
        name: 'FollowProject',
        component: () => import('@/views/follow/follow-project'),
        meta: {
          layout: 'DefaultLayout',
          title: '项目关注',
          pageType: 'public',
          cache: true
        }
      },
      {
        path: 'company',
        name: 'FollowCompany',
        component: () => import('@/views/follow/follow-company'),
        meta: {
          layout: 'DefaultLayout',
          title: '企业/单位关注',
          pageType: 'public',
          cache: true
        }
      }
    ]
  },
  {
    path: '/follow/project/:purchaseId/detail',
    name: 'FollowProjectDetail',
    component: () => import('@/views/follow/follow-project-detail'),
    meta: {
      layout: 'DefaultLayout',
      title: '项目详情'
    }
  },
  {
    path: '/follow/company/:companyId/:companyName/detail',
    name: 'FollowCompanyDetail',
    component: () => import('@/views/follow/follow-company-detail'),
    meta: { layout: 'DefaultLayout', title: '企业/单位相关项目' }
  }
]

export default focusRoutes
